import React from 'react';
import { Breadcrumb } from 'semantic-ui-react';
import '../styles/ContactUs.css'
import { Container, Row, Col } from 'react-bootstrap';



const breadcrumbSections = [
    { key: 'home', content: 'HOME', href: "/" },
    { key: 'contactus', content: 'CONTACT US', active: true },
]
function ContactUs() {

    return (

        <div>
            <div style={{ textAlign: 'left', marginLeft: '70px', marginTop: '80px' }}>
                <Breadcrumb icon='right angle' sections={breadcrumbSections} style={{ backgroundColor: '#fff' }} />
            </div>
            <div className="contact-header">Contact Us</div>
            <div className="contact-columns" style={{ paddingLeft: 'auto', paddingRight: 'auto' }}>
                <Container fluid className="contacts-container">
                    <Row className="align-items-first align-items-start">
                        <Col xs={12} md={6} lg={3}>
                            <div className="contact-info">

                                <div className="department-header">
                                    <h4><b>CORPORATE</b></h4>
                                </div>
                                {/* <div className="sub-department">
                                    <h5><b>Titanium Main Line</b></h5>
                                </div>
                                <div className="contact">
                                    <a href="tel:PHONE_NUM">(844) 225 8874</a>
                                </div>
                                < br /> */}
                                <div className="sub-department">
                                    <h5><b>Investor Relations, Mergers and Acquisitions</b></h5>
                                </div>
                                <div className="contact">
                                    <a href="tel:PHONE_NUM">(905) 266 3011</a>
                                    <br />
                                    <a href={"mailto:"}>investors@ttgi.com</a>
                                    <h8></h8>
                                </div>
                                < br />
                                <div className="sub-department">
                                    <h5><b>Human Resources</b></h5>
                                </div>
                                <div className="contact">
                                    <a href="tel:PHONE_NUM">(905) 266 3076</a>
                                    < br />
                                    <a href={"mailto:"}>hr@ttgi.com</a>
                                </div>
                                < br />
                                <div className="sub-department">
                                    <h5><b>Accounting</b></h5>
                                </div>
                                <div className="contact">
                                    <a href={"mailto:"}>billing@ttgi.com</a>
                                    < br />
                                    <a href={"mailto:"}>podrequests@ttgi.com</a>
                                    < br />
                                    <a href={"mailto:"}>payables@ttgi.com</a>
                                </div>
                                < br />
                                <div className="sub-department">
                                    <h5><b>Driver Recruitment</b></h5>
                                </div>
                                <div className="contact">
                                    <a href="tel:PHONE_NUM">(905) 266 3303</a>

                                    < br />
                                    <a href={"mailto:"}>driverjobs@ttgi.com</a>
                                </div>
                                < br />
                                <div className="sub-department">
                                    <h5><b>Maintenance Team</b></h5>
                                </div>
                                <div className="contact">
                                    <a href="tel:PHONE_NUM">(833) 887 4349 </a>
                                </div>
                            </div>

                        </Col>
                      
                        <Col xs={12} md={6} lg={3}>
                            <div className="contact-info">
                                <div className="department-header">
                                    <h4><b>SALES INQUIRIES</b></h4>
                                </div>
                                <div className="sub-department">
                                    <h5><b>Logistics</b></h5>
                                </div>
                                <div className="contact">
                                    <a href="tel:PHONE_NUM">(905) 266 3057</a>
                                    < br />
                                    <a href={"mailto:"}>rob.thomas@ttgi.com</a>
                                </div>
                                < br />
                                <div className="sub-department">
                                    <h5><b>Warehousing</b></h5>
                                </div>
                                <div className="contact">
                                    <a href="tel:PHONE_NUM">(905) 266 3013</a>
                                    < br />
                                    <a href={"mailto:"}>carmine.imbrogno@ttgi.com</a>
                                </div>
                                < br />
                                < br />
                                < br />
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={3}>
                            <div className="contact-info">
                                <div className="department-header" >

                                    <h4 ><b>LOGISTICS</b></h4>
                                </div>
                                <div className="sub-department">
                                    <h5 ><b>General</b></h5>
                                </div>
                                <div className="contact">
                                    <a href="tel:PHONE_NUM">(905) 851 1688</a>
                                </div>
                                < br />
                                <div className="sub-department">
                                    <h5><b>American Operations Inquiries</b></h5>
                                </div>
                                <div className="contact">
                                    <a href="tel:PHONE_NUM">(704) 713 5611</a>
                                    < br />
                                    <a href={"mailto:"}>charlie.mitchell@ttgi.com</a>
                                </div>
                                < br />.
                            </div>
                        </Col>

                    </Row>
                    <Row className="align-items-first align-items-start" >
                        <Col xs={12} md={6} lg={3}>
                            <div className="contact-info">
                                <div className="department-header" style={{ marginTop: '50px' }}>

                                    <h4><b>AFTER HOURS - CANADIAN</b></h4>
                                </div>
                                <div className="sub-department">
                                    <h5><b>Trucking Dispatch</b></h5>
                                </div>
                                <div className="contact">

                                    <h8><b>All Terminals: </b> <a href="tel:PHONE_NUM">(905) 266 3010 Ext. 1, 3</a></h8>
                                </div>
                                < br />
                                <div className="sub-department">
                                    <h5><b>Logistics Dispatch</b></h5>
                                </div>
                                <div className="contact">

                                    <h8><b>General :</b>  <a href="tel:PHONE_NUM">(905) 851 1688 Ext. 5</a></h8>
                                    < br />
                                    <a href={"mailto:"}>tliafterhours@ttgi.com</a>
                                </div>
                                < br />
                                <div className="sub-department">
                                    <h5><b>Director of Logistics</b></h5>
                                </div>
                                <div className="contact">
                                    <a href="tel:PHONE_NUM">(647) 770 1155</a>
                                    < br />
                                    <a href={"mailto:"}>steffen.hem@ttgi.com</a>
                                </div>
                                <div className="department-header" style={{ marginTop: '50px' }}>
                                    <h4><b>Safety</b></h4>
                                </div>        
                                <div className="contact">

                                    <h8><b>Bolton, ON: </b> <a href="tel:PHONE_NUM">(647) 519 9378</a></h8>
                                    < br />
                                    <a href={"mailto:"}>kevin.brown@ttgi.com</a>
                                    < br />
                                    < br />

                                    <h8><b>Belleville, ON: </b><a href="tel:PHONE_NUM">(613) 961 4728</a></h8>
                                    < br />
                                    <a href={"mailto:"}>steve.farris@ttgi.com</a><h8></h8>
                                    <br />
                                    < br />


                                    <h8><b>Bracebridge, ON: </b>  <a href="tel:PHONE_NUM">(705) 801 5675</a></h8>

                                    < br />
                                    <a href={"mailto:"}>norm.webb@ttgi.com</a>
                                    < br />
                                    < br />


                                    <h8><b>North Bay, ON: </b><a href="tel:PHONE_NUM">(705) 497 4769</a></h8>
                                    < br />
                                    <a href={"mailto:"}>milton.miller@ttgi.com</a>
                                </div>
                                < br />
                                < br />
                            </div>

                 

                        </Col>
                        <Col xs={12} md={6} lg={3}>
                            <div className="contact-info" style={{ marginTop: '50px' }}>

                                <div className="department-header">
                                    <h4><b>AFTER HOURS - AMERICAN</b></h4>
                                </div>
                                
                                <div className="sub-department">
                                    <h5><b>Logistics Emergency</b></h5>
                                </div>
                                <div className="contact">

                                                                        
                                    <h8><b>Atlanta, GA: </b><a href="tel:PHONE_NUM">(470) 372 5060</a></h8>
                                    < br />
                                    <a href={"mailto:"}>dalton.floied@ttgi.com</a>
                                    < br />
                                    < br />
                                    <h8><b>Charlotte, NC: </b> <a href="tel:PHONE_NUM">(704) 703 8004</a></h8>
                                    < br />
                                    <a href={"mailto:"}>john.davis@ttgi.com</a>
                                    < br />
                                    < br />
                                    <h8><b>Chicago, IL: </b><a href="tel:PHONE_NUM">(312) 547 4907</a></h8>
                                    < br />
                                    <a href={"mailto:"}>zachary.payton@ttgi.com</a><h8></h8>
                                    <br />
                                    < br />

                                    <h8><b>Denver, CO: </b>  <a href="tel:PHONE_NUM">(303) 749 8505</a></h8>

                                    < br />
                                    <a href={"mailto:"}>nathan.hart@ttgi.com</a>
                                    < br />< br />


                                    <h8><b>Nashville, TN: </b><a href="tel:PHONE_NUM">(615) 514 1062</a></h8>
                                    < br />
                                    <a href={"mailto:"}>walker.bauer@ttgi.com</a>


                                </div>
                                < br />
                                < br />
                            </div>
                        </Col>

                        <Col xs={12} md={6} lg={3}>
                            <div className="contact-info">
                                <div className="department-header" style={{ marginTop: '50px' }}>

                                    <h4><b>AMERICAN TERMINALS</b></h4>
                                </div>
                                <div className="sub-department">
                                    <h5><b>Atlanta, Georgia </b></h5>
                                </div>
                                <div className="contact">
                                    <h8>2 Ravinia Dr., Suite 910, 30346</h8>
                                    < br />
                                    <a href="tel:PHONE_NUM">(470) 372 5060</a>
                                </div>
                                < br />
                                <div className="sub-department">
                                    <h5><b>Charlotte, North Carolina</b></h5>
                                </div>
                                <div className="contact">
                                    <h8>5950 Fairview Rd., Suite 502, 28210</h8>
                                    < br />
                                    <a href="tel:PHONE_NUM">(704) 703 8002</a>
                                </div>
                                < br />
                                <div className="sub-department">
                                    <h5><b>Chicago, Illinois</b></h5>
                                </div>
                                <div className="contact">
                                    <h8>17 N State, Suite 990, 60602</h8>
                                    < br />
                                    <a href="tel:PHONE_NUM">(312) 547 4907</a>
                                </div>
                                < br />
                                <div className="sub-department">
                                    <h5><b>Denver, Colorado</b></h5>
                                </div>
                                <div className="contact">
                                    <h8>4600 S Ulster St., Suite 1022, 80237</h8>
                                    < br />
                                    <a href="tel:PHONE_NUM">(303) 749 8505</a>
                                </div>
                                < br />
                                <div className="sub-department">
                                    <h5><b>Fayetteville, Arkansas</b></h5>
                                </div>
                                <div className="contact">
                                    <h8>2828 N Mansfield St., Suite 101, 72704</h8>
                                    < br />
                                    <a href="tel:PHONE_NUM">(479) 225 2889</a>
                                </div>
                                < br />
                                <div className="sub-department">
                                    <h5><b>Nashville, Tennessee</b></h5>
                                </div>
                                <div className="contact">
                                    <h8>3310 West End Ave, Suite 410, 37203</h8>
                                    < br />
                                    <a href="tel:PHONE_NUM">(615) 514 1061</a>
                                </div>
                                < br />

                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={3}>
                            <div className="contact-info" style={{ marginTop: '50px' }}>
                                <div className="department-header">
                                    <h4><b>CANADIAN TERMINALS</b></h4>
                                </div>
                                <div className="sub-department">
                                    <h5><b>Bolton, Ontario (head office)</b></h5>
                                </div>
                                <div className="contact">
                                    <h8>32 Simpson Road, L7E 1G9</h8>
                                    < br />
                                    <a href="tel:PHONE_NUM">(905) 266 3010</a>
                                </div>
                                < br />
                                <div className="contact-info">
                                    <div className="sub-department">
                                        <h5><b>Belleville, Ontario</b></h5>
                                    </div>
                                    <div className="contact">
                                        <h8>107 Bellevue Drive, K8N 4Z5</h8>
                                        < br />
                                        <a href="tel:PHONE_NUM"> (613) 961 4700</a>
                                        <h8></h8>
                                    </div>
                                    < br />


                                    <div className="sub-department">
                                        <h5><b>Bracebridge, Ontario</b></h5>
                                    </div>
                                    <div className="contact">
                                        <h8>456 Ecclestone Drive, P1L 1R1</h8>
                                        < br />
                                        <a href="tel:PHONE_NUM">(705) 645 4481</a>
                                    </div>
                                    < br />
                                    <div className="sub-department">
                                        <h5><b>Brantford, Ontario</b></h5>
                                    </div>
                                    <div className="contact">
                                        <h8>31 Ewart Ave, Brantford, ON N3T 5M1</h8>
                                        < br />
                                        <a href="tel:PHONE_NUM">(519) 720 2575</a>
                                    </div>
                                    < br />
                                    <div className="sub-department">
                                        <h5><b>Cornwall, Ontario </b></h5>
                                    </div>
                                    <div className="contact">
                                        <h8>1750B McConnell Ave, K6H 5R6</h8>
                                        < br />
                                        <a href="tel:PHONE_NUM">(613) 930 7350</a>
                                    </div>
                                    < br />
                                    <div className="sub-department">
                                        <h5><b>Montréal, Québec</b></h5>
                                    </div>
                                    <div className="contact">
                                        <h8>3100 Blvd. Cote-Vertu Ouest, Suite 230, H4R 2J8</h8>
                                        < br />
                                        <a href="tel:PHONE_NUM">(514) 805 8222</a>
                                    </div>
                                    < br />
                                    <div className="sub-department">
                                        <h5><b>Napanee, Ontario</b></h5>
                                    </div>
                                    <div className="contact">
                                        <h8>824 Highway 41, K0K 2Z0</h8>
                                        < br />
                                        <a href="tel:PHONE_NUM">(613) 354 6336</a>
                                    </div>
                                    < br />
                                    <div className="sub-department">
                                        <h5><b>North Bay, Ontario </b></h5>
                                    </div>
                                    <div className="contact">
                                        <h8>348 Birch's Road, P1B 8Z4</h8>
                                        < br />
                                        <a href="tel:PHONE_NUM">(705) 476 4411</a>
                                    </div>
                                    < br />
                                    <div className="sub-department">
                                        <h5><b>Windsor, Ontario</b></h5>
                                    </div>
                                    <div className="contact">
                                        <h8>3315 Devon Drive, N8X 4L5</h8>
                                        < br />
                                        <a href="tel:PHONE_NUM">(519) 972 3401</a>
                                    </div>
                                    < br />
                                    < br />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>


        </div>
    )
}

export default ContactUs
